import { useEffect, useState } from 'preact/hooks';

export function useIsWide(minWidth: number = 900): boolean {
  const query = `(min-width: ${minWidth}px)`;
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof matchMedia === 'undefined') return false;
    return matchMedia(query).matches;
  });
  useEffect(() => {
    if (typeof matchMedia === 'undefined') return;
    const mql = matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}
